import Seo from "@/components/Seo";
import { Eyebrow, Section, StatusChip } from "@/components/Type";
import { useWaitlist } from "@/context/waitlist";
import { PROGRAMMES } from "@/content/programmes";

const Field = ({ label, value }) => (
  <div>
    <p className="font-mono text-[9px] tracking-[0.3em] text-[#57534a]">{label}</p>
    <p className="mt-2 text-sm leading-relaxed text-[#8e8a80]">{value}</p>
  </div>
);

export default function ProgrammesPage() {
  const openWaitlist = useWaitlist();

  return (
    <>
      <Seo
        title="Programmes | W8ED"
        description="W8ED programmes turn the eight-pillar system into structured, repeatable health practice."
        path="/programmes"
      />
      <section className="px-6 pb-20 pt-32 sm:pt-40">
        <div className="mx-auto max-w-6xl">
          <Eyebrow>Programmes</Eyebrow>
          <h1 className="mt-8 max-w-4xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-[#f5f2ea] sm:text-6xl">
            HEALTH IS SOMETHING WE BUILD.
          </h1>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-[#8e8a80]">
            Structure beats motivation. W8ED programmes turn the system into something repeatable —
            measured, reviewed and adapted over time. Nothing here is live yet. When it is, it will
            be earned.
          </p>
        </div>
      </section>

      <Section className="py-0 sm:py-0">
        <div className="space-y-px border border-[#1f1e1a] bg-[#1f1e1a]">
          {PROGRAMMES.map((p) => (
            <article key={p.id} id={p.id} className="scroll-mt-24 bg-[#0a0a09] p-8 sm:p-12" data-testid={`programme-${p.id}`}>
              <div className="flex flex-wrap items-center gap-4">
                <h2 className="font-display text-2xl font-extrabold tracking-tight text-[#f5f2ea] sm:text-3xl">
                  {p.name}
                </h2>
                <StatusChip status={p.status} />
              </div>
              <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
                <Field label="WHO IT IS FOR" value={p.whoFor} />
                <Field label="DURATION" value={p.duration} />
                <Field label="METHODOLOGY" value={p.methodology} />
                <Field label="WHAT IS MEASURED" value={p.measured} />
                <Field label="WHAT IS INCLUDED" value={p.included} />
                <Field label="THE JOURNEY" value={p.journey} />
                <Field label="OUTCOMES" value={p.outcomes} />
              </div>
              <button
                type="button"
                data-testid={`programme-join-${p.id}`}
                onClick={openWaitlist}
                className="mt-10 border border-[#3a3524] px-6 py-3 font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9A227] transition-colors hover:border-[#C9A227]"
              >
                JOIN THE W8LIST
              </button>
            </article>
          ))}
        </div>
      </Section>
      <div className="py-16" />
    </>
  );
}
